// Bitcoin Markets Data - Centralized data for Bitcoin prediction markets
import * as React from 'react';
import { Box, Typography } from '@mui/material';

export interface BitcoinMarketData {
  id: string;
  slug: string;
  question: string;
  volume: string;
  endDate: string;
  outcomes: Array<{
    id: string;
    priceTarget: string;
    volume: string;
    percentage: string;
    change?: string;
    yesPrice: string;
    noPrice: string;
  }>;
  description: string;
  selectedOutcome?: string;
  clobTokenIds?: string[];
}

// Bitcoin Logo Component
const BitcoinLogo = () => (
  <Box
    sx={{
      width: 40,
      height: 40,
      borderRadius: '50%',
      bgcolor: '#f97316',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
    }}
  >
    <Typography
      sx={{
        fontSize: '1.5rem',
        fontWeight: 700,
        color: '#ffffff',
        lineHeight: 1,
        fontFamily: 'system-ui, -apple-system, sans-serif',
      }}
    >
      B
    </Typography>
    <Typography
      sx={{
        fontSize: '0.875rem',
        fontWeight: 700,
        color: '#ffffff',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%) translateY(-3px)',
        lineHeight: 1,
        fontFamily: 'system-ui, -apple-system, sans-serif',
      }}
    >
      $
    </Typography>
  </Box>
);

export const BITCOIN_MARKETS: BitcoinMarketData[] = [
  {
    id: 'btc-price-dec-19',
    slug: 'bitcoin-above-dec-22',
    question: 'Bitcoin above ____ on December 22?',
    volume: '$1,577,897',
    endDate: 'December 22, 2024',
    outcomes: [
      {
        id: '76000',
        priceTarget: '76,000',
        volume: '$56,695',
        percentage: '100%',
        yesPrice: '100¢',
        noPrice: '0.1¢',
      },
      {
        id: '78000',
        priceTarget: '78,000',
        volume: '$72,241',
        percentage: '100%',
        yesPrice: '0.0¢',
        noPrice: '0.1¢',
      },
      {
        id: '80000',
        priceTarget: '80,000',
        volume: '$127,913',
        percentage: '100%',
        yesPrice: '0.0¢',
        noPrice: '0.1¢',
      },
      {
        id: '82000',
        priceTarget: '82,000',
        volume: '$205,245',
        percentage: '100%',
        change: '▲1%',
        yesPrice: '0.0¢',
        noPrice: '0.1¢',
      },
      {
        id: '84000',
        priceTarget: '84,000',
        volume: '$198,350',
        percentage: '100%',
        change: '▲4%',
        yesPrice: '99.8¢',
        noPrice: '0.3¢',
      },
      {
        id: '86000',
        priceTarget: '86,000',
        volume: '$187,204',
        percentage: '99%',
        change: '▲14%',
        yesPrice: '98.7¢',
        noPrice: '1.4¢',
      },
      {
        id: '88000',
        priceTarget: '88,000',
        volume: '$150,000',
        percentage: '90%',
        change: '▲35%',
        yesPrice: '90¢',
        noPrice: '11¢',
      },
    ],
    description:
      'This market resolves to Yes if the price of Bitcoin is above the target price on the specified date. Resolution will be based on the CoinGecko price.',
    selectedOutcome: '80000',
  },
];

export const getBitcoinMarketById = (id: string): BitcoinMarketData | undefined => {
  return BITCOIN_MARKETS.find((market) => market.id === id);
};

export { BitcoinLogo };
